import { useEffect, useRef, useState } from "react";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import localeText from "../../../../locale";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import ProductService from "../../../../service/ProductService";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { Editor } from "primereact/editor";
import DOMPurify from "dompurify";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import useCategories from "../../../../hooks/useCategories";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { Dropdown } from "primereact/dropdown";
import { locale } from "../../../../utilities/locale/locale";
import { Dialog } from "primereact/dialog";
import { useToggle } from "../../../../hooks/useToggle";
import { RadioButton } from "primereact/radiobutton";
import { InputNumber } from "primereact/inputnumber";
import { localeISO } from "../../../../utilities/localeIso";

const freightRules = [
  { id: "DISCOUNTPERCENTUAL", value: "DISCOUNTPERCENTUAL", label: "discountPercentual" },
  { id: "DISCOUNTABSOLUT", value: "DISCOUNTABSOLUT", label: "discountAbsolut" },
  { id: "FREE", value: "FREE", label: "free" },
];

const UserStore = (props) => {
  const { showErrorToast, showSuccessToast } = useToastContext();
  const [userStoreInfo, setUserStoreInfo] = useState(null);
  const [loadingStore, setLoadingStore] = useState(true);
  const [loadingConfirmChanges, setLoadingConfirmChanges] = useState(false);

  const [logo, setLogo] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [characterLimit, setCharacterLimit] = useState(17);
  const [loaded, setLoaded] = useState(false);

  // Social media
  const [facebookLink, setFacebookLink] = useState("");
  const [twitterLink, setTwitterLink] = useState("");
  const [instagramLink, setInstagramLink] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
  const [siteLink, setSiteLink] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [tiktok, setTiktok] = useState("");
  const [slug, setSlug] = useState("");
  const [showCropper, setShowCropper] = useState(false);
  const [image, setImage] = useState(null);
  const { value, setAsTrue, setAsFalse } = useToggle();

  const [freightRule, setFreightRule] = useState();
  const [valueToActivatefreightRule, setValueToActivatefreightRule] = useState();
  const [freightRuleInput, setFreightRuleInput] = useState();
  const [isLoadingFreightRule, setIsLoadingFreightRule] = useState(true);
  const [isLoadingPostFreightRule, setIsLoadingPostFreightRule] = useState(false);

  const getUserInfoService = new GetUserInfoService();
  const productService = new ProductService();

  const fileUploadRef = useRef(null);
  const cropperRef = useRef(null);

  const uploadOptions = {
    className: "hidden",
  };

  const handleSuccessCategories = (categories) => {
    const categoriesArray = categories?.map((category) => {
      const localeOptions = {
        en: category?.descriptionEnglish,
        it: category?.descriptionItalian,
        pt: category?.descriptionPortuguese,
        es: category?.descriptionSpanish,
      };

      const categoryLabel = localeOptions[locale];

      return {
        label: categoryLabel,
        value: {
          id: category?.id,
          label: categoryLabel,
        },
      };
    });

    return {
      result: categoriesArray,
    };
  };

  const { categories, loadingCategories } = useCategories({
    onSuccess: handleSuccessCategories,
    onCategoriesError: (code) => showErrorToast({ code }),
  });

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [removedCategories, setRemovedCategories] = useState([]);

  function dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const onImageChange = (e) => {
    const files = Array.from(e.files);
    const reader = new FileReader();

    reader.onload = () => {
      setImage(reader.result);
      setShowCropper(true);
    };

    reader.readAsDataURL(files[0]);
  };

  const getCroppedImage = () => {
    if (cropperRef.current) {
      const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
      const croppedImageBase64 = croppedCanvas.toDataURL();

      const img = new Image();
      img.src = croppedImageBase64;
      img.onload = function () {
        const croppedImageFile = dataURLtoFile(croppedImageBase64, "croppedImage.png");

        setLogo(croppedImageFile);
        uploadImages(croppedImageFile);
        setShowCropper(false);
      };
    }
  };

  const getFreightRules = async () => {
    try {
      setIsLoadingFreightRule(true);

      const res = await getUserInfoService.getFreightRules();

      if (res.result) {
        setFreightRule(res.result.freightRule);
        setValueToActivatefreightRule(res.result.minimumOrderValue);
        setFreightRuleInput(res.result.freightDiscount);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoadingFreightRule(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoadingStore(true);

      if (props.plan === "Partner" || props.plan === "Manager" || props.plan === "Seller") {
        const res = await getUserInfoService.getUserShop(
          localStorage.getItem("__extraconomy_username")
        );

        if (res.messageCode !== 200001) {
          showErrorToast({ code: res.messageCode });

          if (res.messageCode === 500000) console.log(res);
          setLoadingStore(false);
        } else {
          setUserStoreInfo(res.result.shopConfiguration);
          if (res.result.shopConfiguration) {
            setTitle(res.result.shopConfiguration.title);
            setDescription(res.result.shopConfiguration.description);
            setLoaded(true);
            setLogo(res.result.shopConfiguration.imagelogoid);
            setCharacterLimit(res.result.shopConfiguration.title.length - 17);
            setInstagramLink(res.result.shopConfiguration.instagram);
            setSlug(res.result.shopConfiguration.slug);
            setLinkedin(res.result.shopConfiguration.linkedin);
            setTiktok(res.result.shopConfiguration.tiktok);
            setTwitterLink(res.result.shopConfiguration.twitter);
            setFacebookLink(res.result.shopConfiguration.facebook);
            setYoutubeLink(res.result.shopConfiguration.youtube);
            setSiteLink(res.result.shopConfiguration.website);
            const selectedCategoriesInShop = handleSuccessCategories(
              res.result.shopConfiguration?.categories ?? []
            );
            setSelectedCategories(
              selectedCategoriesInShop?.result?.map((category) => category.value)
            );
          }
          setLoadingStore(false);
        }
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    } finally {
      setLoadingStore(false);
    }
  };

  useEffect(() => {
    fetchData();
    getFreightRules(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uploadImages = async (image) => {
    try {
      if (image && typeof image !== "string") {
        const res = await productService.postUploadImage(
          localStorage.getItem("__extraconomy_token"),
          image
        );
        if (res.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode });

          if (res.messageCode === 500000) console.log(res);
          return false;
        } else {
          return res.result;
        }
      } else {
        return null;
      }
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        showErrorToast({ detail: "unexpectedSystemBehaviour" });
      } else {
        showErrorToast({ detail: "unexpectedErrorUploadImg" });
      }
    }
  };

  const setUpStore = async (editing) => {
    try {
      setLoadingConfirmChanges(true);

      let uploadLogo = null;

      if (typeof logo !== "string") uploadLogo = await uploadImages(logo);
      const urlUsed = [
        "cart",
        "privacy",
        "store",
        "product",
        "shop",
        "comingsoon",
        "salepromoter",
        "seller",
        "specialcustomer",
        "areamanager",
        "businesspartner",
        "orderconfirmation",
        "emailconfirmation",
        "login",
      ];

      if (value && urlUsed.includes(slug?.toLowerCase())) {
        showErrorToast({ code: 500198 });

        setLoadingConfirmChanges(false);
        return;
      }

      const res = await getUserInfoService.postEditShop(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        title,
        description,
        uploadLogo ? uploadLogo : userStoreInfo.imagelogoid,
        instagramLink,
        twitterLink,
        facebookLink,
        youtubeLink,
        siteLink,
        linkedin,
        tiktok,
        slug
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });

        if (res.messageCode === 500000) console.log(res);
        setLoadingConfirmChanges(false);
      } else {
        if (!editing) {
          showSuccessToast({ detail: "storeSetUpSuccessfully" });
        } else {
          showSuccessToast({ detail: "storeEditedSuccessfully" });
        }
        const resLinkCategories = await getUserInfoService.linkCategoryToStore(
          localStorage.getItem("__extraconomy_token"),
          selectedCategories.map((category) => category.id),
          userStoreInfo.id
        );

        removedCategories?.forEach(async (categoryId) => {
          await getUserInfoService.unlinkCategoryToStore(
            localStorage.getItem("__extraconomy_token"),
            categoryId,
            userStoreInfo.id
          );
        });

        if (resLinkCategories.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode });
        }
        setUserStoreInfo(res.result);
        setLoadingConfirmChanges(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    }
  };

  const handlePostFreightSettings = async () => {
    try {
      setIsLoadingPostFreightRule(true);

      const res = await getUserInfoService.postFreightRule({
        freightRule: freightRule,
        minimumOrderValue: valueToActivatefreightRule,
        freightDiscount: freightRuleInput,
      });

      if (res.messageCode === 200000 || res.messageCode === 200001) {
        showSuccessToast({ detail: "successSaveFreightRule" });
        return;
      }

      showErrorToast({ code: res.messageCode });
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else {
        showErrorToast({ code: 500000 });
      }
    } finally {
      setIsLoadingPostFreightRule(false);
    }
  };

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <select className="ql-size">
          <option defaultValue="">{localeText("normal")}</option>
          <option value="huge">{localeText("heading")}</option>
          <option value="large">{localeText("subheading")}</option>
        </select>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
          <button className="ql-underline" aria-label="Underline"></button>
        </span>
        <span className="ql-formats">
          <button type="button" className="ql-list" value="ordered" aria-label="Ordered List">
            <svg viewBox="0 0 18 18">
              {" "}
              <line className="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>{" "}
              <line className="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"></line>{" "}
              <path
                className="ql-fill"
                d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
              ></path>{" "}
              <path
                className="ql-stroke ql-thin"
                d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
              ></path>{" "}
              <path
                className="ql-stroke ql-thin"
                d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
              ></path>{" "}
            </svg>
          </button>
          <button type="button" className="ql-list" value="bullet" aria-label="Unordered List">
            <svg viewBox="0 0 18 18">
              {" "}
              <line className="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>{" "}
            </svg>
          </button>
        </span>
      </span>
    );
  };

  const handleChangeSlug = (slug) => {
    const formatedSlug = slug?.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase();
    setSlug(formatedSlug);
  };

  const header = renderHeader();

  return (
    <div className="card border-1 border-300">
      {props.plan === "Manager" || props.plan === "Seller" ? (
        <>
          {loadingStore && loadingCategories ? (
            <div className="text-center my-8">
              <i className="pi pi-spin pi-spinner text-400 text-8xl"></i>
            </div>
          ) : (
            <>
              <Dialog
                header={`Slug (${localeText("slug")})`}
                visible={value}
                className="w-30rem m-2"
                onHide={setAsFalse}
                draggable={false}
              >
                <div className="flex align-items-center mb-4">
                  <span className="text-700 mr-1">https://extraconomy.com/</span>
                  <InputText
                    className="w-full"
                    name="slug"
                    value={slug ?? ""}
                    maxLength={20}
                    onChange={(e) => handleChangeSlug(e.target.value)}
                  />
                </div>

                <div className="flex justify-content-end">
                  <Button
                    label={localeText("confirmChanges")}
                    className="mb-4"
                    size="small"
                    loading={loadingConfirmChanges}
                    onClick={() => setUpStore(true)}
                  />
                </div>
              </Dialog>

              {userStoreInfo ? (
                <>
                  <div className="flex justify-content-between align-items-center flex-wrap">
                    <h3 className="my-4">{localeText("yourStore")}</h3>

                    <Button
                      label={localeText("linkStore")}
                      className="my-4"
                      size="small"
                      onClick={setAsTrue}
                    />
                  </div>
                  <hr />

                  <h5>{localeText("editYourStore")}</h5>

                  <AdvancedImage
                    cldImg={cloudinaryInstance
                      .image(typeof logo === "string" ? logo : userStoreInfo.imagelogoid)
                      .resize(fill().width(1200).height(300))
                      .format("webp")}
                    className="w-full mt-2 border-round"
                  />

                  <p className="text-700 mb-4">{localeText("logoWrongAspectRatio")}</p>

                  <FileUpload
                    uploadOptions={uploadOptions}
                    chooseLabel={localeText("choose")}
                    cancelLabel={localeText("cancel")}
                    className="mt-2 w-full"
                    name="demo"
                    onSelect={onImageChange}
                    onClear={() => setLogo(null)}
                    onRemove={() => setLogo(null)}
                    onError={() => setLogo(null)}
                    onValidationFail={() => setLogo(null)}
                    accept="image/*"
                    ref={fileUploadRef}
                    emptyTemplate={
                      <div className="text-center">
                        <i className="pi pi-upload text-400" style={{ fontSize: "3em" }}></i>
                        <h3 className="text-400">{localeText("dragImgFile")}</h3>
                      </div>
                    }
                  />

                  {showCropper && (
                    <div>
                      <Cropper
                        ref={cropperRef}
                        src={image}
                        style={{ height: 400, width: "100%", marginBottom: 10 }}
                        aspectRatio={4 / 1}
                      />
                      <Button onClick={getCroppedImage}>{localeText("cropImage")}</Button>
                    </div>
                  )}

                  <div className="my-4">
                    <label htmlFor="title">{localeText("title")}</label>
                    <InputText
                      className="w-full my-2"
                      name="title"
                      value={title ?? ""}
                      onChange={(e) => {
                        if (e.target.value.length <= 17) {
                          setTitle(e.target.value);
                          setCharacterLimit(Math.abs(e.target.value.length - 17));
                        }
                      }}
                    />

                    <div className="flex justify-content-between">
                      <div></div>
                      <span className="text-500">{characterLimit}</span>
                    </div>

                    <label htmlFor="description">{localeText("description")}</label>
                    {loaded && (
                      <Editor
                        headerTemplate={header}
                        value={description}
                        className="my-2"
                        onTextChange={(e) => setDescription(DOMPurify.sanitize(e.htmlValue))}
                        style={{ height: "256px" }}
                      />
                    )}

                    <div className="mt-4 mb-2">
                      <label htmlFor="socialMedia">Slug ({localeText("slug")})</label>
                    </div>

                    <div className="mt-4 mb-2">
                      <label htmlFor="socialMedia">{localeText("socialMedia")}</label>
                    </div>

                    <div className="grid">
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-instagram text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://instagram.com/</span>
                          <InputText
                            className="w-full"
                            name="instagram"
                            value={instagramLink ?? ""}
                            onChange={(e) => setInstagramLink(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-twitter text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://twitter.com/</span>
                          <InputText
                            className="w-full"
                            name="twitter"
                            value={twitterLink ?? ""}
                            onChange={(e) => setTwitterLink(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-facebook text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://facebook.com/</span>
                          <InputText
                            className="w-full"
                            name="facebook"
                            value={facebookLink ?? ""}
                            onChange={(e) => setFacebookLink(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-youtube text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://youtube.com/</span>
                          <InputText
                            className="w-full"
                            name="youtube"
                            value={youtubeLink ?? ""}
                            onChange={(e) => setYoutubeLink(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-linkedin text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://linkedin.com/</span>
                          <InputText
                            className="w-full"
                            name="linkedin"
                            value={linkedin ?? ""}
                            onChange={(e) => setLinkedin(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-tiktok text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://tiktok.com/@</span>
                          <InputText
                            className="w-full"
                            name="tiktok"
                            value={tiktok ?? ""}
                            onChange={(e) => setTiktok(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-2">
                          <label htmlFor="site">Website</label>
                        </div>
                        <div className="flex align-items-center">
                          <i className="pi pi-link text-700 mr-2"></i>
                          <InputText
                            className="w-full"
                            name="site"
                            value={siteLink ?? ""}
                            onChange={(e) => setSiteLink(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <ManageStoreCategories
                    selectedCategories={selectedCategories}
                    categories={categories}
                    setSelectedCategories={setSelectedCategories}
                    setRemovedCategories={setRemovedCategories}
                  />

                  <Button
                    label={localeText("confirmChanges")}
                    className="mb-4"
                    loading={loadingConfirmChanges}
                    onClick={() => setUpStore(true)}
                  />

                  {isLoadingFreightRule ? (
                    <div className="text-center my-8">
                      <i className="pi pi-spin pi-spinner text-400 text-8xl"></i>
                    </div>
                  ) : (
                    <>
                      <hr />

                      <div>
                        <h2>{localeText("feightRules")}</h2>
                        <p>{localeText("setShippingRulesForYourStore")}</p>

                        <div className="flex gap-2 flex-row mb-4">
                          {freightRules.map(({ id, value, label }) => (
                            <div key={id}>
                              <RadioButton
                                inputId={`${id}`}
                                value={value}
                                onChange={(e) => setFreightRule(e.value)}
                                checked={freightRule === value}
                              />
                              <label htmlFor={`${id}`} className="pl-2 cursor-pointer">
                                {localeText(label)}
                              </label>
                            </div>
                          ))}
                        </div>

                        {freightRule !== "" && (
                          <div className="mb-4">
                            <label>{localeText("minimalOrderValueToActivateSetting")}</label>

                            <InputNumber
                              mode="currency"
                              currency={props.currency}
                              locale={localeISO}
                              className="w-full mt-2"
                              value={valueToActivatefreightRule}
                              onValueChange={(e) => setValueToActivatefreightRule(e.value)}
                            />
                          </div>
                        )}

                        {(freightRule === "DISCOUNTPERCENTUAL" ||
                          freightRule === "DISCOUNTABSOLUT") && (
                          <div className="mb-4">
                            <label>
                              {freightRule === "DISCOUNTPERCENTUAL" &&
                                `${localeText("percentual")} (%)`}

                              {freightRule === "DISCOUNTABSOLUT" && `${localeText("value")}`}
                            </label>

                            <div>
                              {freightRule === "DISCOUNTPERCENTUAL" && (
                                <InputNumber
                                  value={freightRuleInput}
                                  onValueChange={(e) => setFreightRuleInput(e.value)}
                                  suffix="%"
                                  mode="decimal"
                                  className="w-full mt-2"
                                  min={0}
                                  max={100}
                                />
                              )}

                              {freightRule === "DISCOUNTABSOLUT" && (
                                <InputNumber
                                  mode="currency"
                                  currency={props.currency}
                                  locale={localeISO}
                                  className="w-full mt-2"
                                  value={freightRuleInput}
                                  onValueChange={(e) => setFreightRuleInput(e.value)}
                                />
                              )}
                            </div>
                          </div>
                        )}

                        <Button
                          label={localeText("confirmChanges")}
                          className="mb-4"
                          loading={isLoadingPostFreightRule}
                          onClick={handlePostFreightSettings}
                        />
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <h3 className="my-4">{localeText("setUpStore")}</h3>
                  <hr />

                  <h5>{localeText("userStoreExplanation")}</h5>

                  <FileUpload
                    uploadOptions={uploadOptions}
                    chooseLabel={localeText("choose")}
                    cancelLabel={localeText("cancel")}
                    className="mt-4"
                    name="demo"
                    onSelect={onImageChange}
                    onClear={() => setLogo(null)}
                    onRemove={() => setLogo(null)}
                    onError={() => setLogo(null)}
                    onValidationFail={() => setLogo(null)}
                    accept="image/*"
                    ref={fileUploadRef}
                    emptyTemplate={
                      <div className="text-center">
                        <i className="pi pi-upload text-400" style={{ fontSize: "3em" }}></i>
                        <h3 className="text-400">{localeText("dragImgFile")}</h3>
                      </div>
                    }
                  />

                  {showCropper && (
                    <div>
                      <Cropper
                        ref={cropperRef}
                        src={image}
                        style={{ height: 400, width: "100%", marginBottom: 10 }}
                        aspectRatio={4 / 1}
                      />
                      <Button onClick={getCroppedImage}>{localeText("cropImage")}</Button>
                    </div>
                  )}

                  <p className="text-700 mt-2">{localeText("logoWrongAspectRatio")}</p>

                  <div className="my-4">
                    <label htmlFor="title">{localeText("title")}</label>
                    <InputText
                      className="w-full my-2"
                      name="title"
                      value={title ?? ""}
                      onChange={(e) => {
                        if (e.target.value.length <= 17) {
                          setTitle(e.target.value);
                          setCharacterLimit(Math.abs(e.target.value.length - 17));
                        }
                      }}
                    />

                    <div className="flex justify-content-between">
                      <div></div>
                      <span className="text-500">{characterLimit}</span>
                    </div>

                    <label htmlFor="description">{localeText("description")}</label>
                    <Editor
                      headerTemplate={header}
                      value={description}
                      className="my-2"
                      onTextChange={(e) => setDescription(DOMPurify.sanitize(e.htmlValue))}
                      style={{ height: "256px" }}
                    />

                    <div className="mt-4 mb-2">
                      <label htmlFor="socialMedia">Slug ({localeText("slug")})</label>
                    </div>

                    <div className="flex align-items-center">
                      <span className="text-700 mr-1">https://extraconomy.com/</span>
                      <InputText
                        className="w-full"
                        name="slug"
                        value={slug ?? ""}
                        onChange={(e) => setSlug(e.target.value)}
                      />
                    </div>

                    <div className="mt-4 mb-2">
                      <label htmlFor="socialMedia">{localeText("socialMedia")}</label>
                    </div>

                    <div className="grid">
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-instagram text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://instagram.com/</span>
                          <InputText
                            className="w-full"
                            name="instagram"
                            value={instagramLink ?? ""}
                            onChange={(e) => setInstagramLink(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-twitter text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://twitter.com/</span>
                          <InputText
                            className="w-full"
                            name="twitter"
                            value={twitterLink ?? ""}
                            onChange={(e) => setTwitterLink(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-facebook text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://facebook.com/</span>
                          <InputText
                            className="w-full"
                            name="facebook"
                            value={facebookLink ?? ""}
                            onChange={(e) => setFacebookLink(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-youtube text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://youtube.com/</span>
                          <InputText
                            className="w-full"
                            name="youtube"
                            value={youtubeLink ?? ""}
                            onChange={(e) => setYoutubeLink(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-linkedin text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://linkedin.com/</span>
                          <InputText
                            className="w-full"
                            name="linkedin"
                            value={linkedin ?? ""}
                            onChange={(e) => setLinkedin(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="lg:col-6 md:col-6 col-12">
                        <div className="flex align-items-center">
                          <i className="pi pi-tiktok text-700 mr-2"></i>
                          <span className="text-700 mr-1">https://tiktok.com/</span>
                          <InputText
                            className="w-full"
                            name="tiktok"
                            value={tiktok ?? ""}
                            onChange={(e) => setTiktok(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-2">
                          <label htmlFor="site">Website</label>
                        </div>
                        <div className="flex align-items-center">
                          <i className="pi pi-link text-700 mr-2"></i>
                          <InputText
                            className="w-full"
                            name="site"
                            value={siteLink ?? ""}
                            onChange={(e) => setSiteLink(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <ManageStoreCategories
                    selectedCategories={selectedCategories}
                    categories={categories}
                    setSelectedCategories={setSelectedCategories}
                    setRemovedCategories={setRemovedCategories}
                  />

                  <Button
                    label={localeText("confirm")}
                    className="mb-4"
                    loading={loadingConfirmChanges}
                    onClick={() => setUpStore(false)}
                  />
                </>
              )}
            </>
          )}
        </>
      ) : (
        <div className="text-center">
          <i className="pi pi-lock text-8xl text-400 my-4"></i>
          <h2 className="my-6">{localeText("planNotAllowed")}</h2>
        </div>
      )}
    </div>
  );
};

const ManageStoreCategories = ({
  selectedCategories,
  categories,
  setSelectedCategories,
  setRemovedCategories,
}) => {
  return (
    <div className="mb-4">
      <h2>{localeText("addCategory")}</h2>

      <div>
        <Dropdown
          className="w-full my-2"
          value={selectedCategories[selectedCategories?.length - 1]}
          options={categories}
          editable={false}
          onChange={(e) => {
            setSelectedCategories((oldState) => {
              const exists = oldState.some((old) => e.value?.id === old?.id);
              if (!exists) return [...oldState.push(e.value)];
              return [...oldState];
            });
            setRemovedCategories((oldState) => {
              return oldState.filter((element) => element !== e.value?.id);
            });
          }}
          style={{ minWidth: "108px" }}
        />
      </div>

      <div className="flex justify-content-start align-content-center flex-wrap">
        {selectedCategories.map((category, index) => {
          return (
            <li
              className="border-2 border-400 mt-4 mx-2 p-2 list-none"
              style={{ borderRadius: "4em" }}
              key={index}
            >
              {category.label}{" "}
              <span
                className="mx-2 cursor-pointer text-xs"
                style={{ fontWeight: "bold" }}
                onClick={() => {
                  setSelectedCategories((oldState) => {
                    return oldState.filter((element) => element?.id !== category?.id);
                  });
                  setRemovedCategories((oldState) => {
                    return [...oldState, category?.id];
                  });
                }}
              >
                X
              </span>
            </li>
          );
        })}
      </div>
    </div>
  );
};

export default UserStore;
